import { render, staticRenderFns } from "./CardPesticides.vue?vue&type=template&id=0e95fb82&scoped=true"
import script from "./CardPesticides.vue?vue&type=script&lang=js"
export * from "./CardPesticides.vue?vue&type=script&lang=js"
import style0 from "./CardPesticides.vue?vue&type=style&index=0&id=0e95fb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e95fb82",
  null
  
)

export default component.exports